import React from 'react';
import { ContactForm } from '../../components/ContactForm';
export function ContactFormForm() {
  return <>
      {/* === INSERT WEBSITEFORGE CONTACT FORM FRAME HERE === */}
      {/* Replace the <ContactForm /> below with the live WebsiteForge */}
      {/* contact form embed in production so submissions reach Storm. */}
      <ContactForm defaultTopic="Question" data-id="element-866" />
    </>;
}